import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { Link, redirect } from "react-router-dom";
import logo from "../../../assests/Daalchini-logo.svg";
import JunkFood from "../../../assests/JunkFood.png";
import phone from "../../../assests/phone.svg";
import lock from "../../../assests/lock.svg";
import Home from "../../Home/component";
import LoadingSpinner from "../../Loading/component";
import eyeIcon from "../../../assests/eyeIcon.svg";
import refillEye from "../../../assests/refillEye.svg";
import hideEyeIcon from "../../../assests/crossEye.svg";
import CircularProgress from "@mui/material/CircularProgress";
import christmislogo from "../../../assests/christmis-logo.png"
const Login = ({
  mobile,
  password,
  disabled,
  loading,
  onSubmit,
  onChanegOfMobile,
  onChangeOfPassword,
  keyDownHandler,
  handleKeyDown,
  error,
  showPassword,
  setShowPassword,
}) => {
  let navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("data")
    ? JSON.parse(localStorage.getItem("data"))
    : false;
  if (isAuthenticated && isAuthenticated.accessToken) {
    return <Home />;
  }

  const inputStyle = {
    borderRadius: "18px",
    padding: "12px 48px 14px",
    fontSize: "20px",
    background: "#FFFFFF",
    color: "#111111",
  };
  const inputStylePassword = {
    borderRadius: "18px",
    padding: "12px 52px 14px ",
    fontSize: "20px",
    background: "#FFFFFF",
  };

  const signinStyle = {
    borderRadius: "18px",
    padding: "12px 32px 14px",
    fontSize: "20px",
    textTransform: "uppercase",
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="login-container">
          <div className="blurd"> </div>
          <div className="login-left">
            <img className="logo" src={logo} alt="" />
            <img src={JunkFood} alt="" className="illustration" />
          </div>
         
          <div className="login-right">

            <h2 className="heading">Sign In to Daalchini</h2>

            <form onSubmit={onSubmit} className="login-form">

              <div className="input-container">
                <img
                  className="input-icon"
                  src={phone}
                  alt=""
                />
                <input
                  maxLength="10"
                  style={inputStyle}
                  // type="number"
                  required="true"
                  className="form-control"
                  placeholder="Enter Your Mobile Number"
                  aria-label="m Number"
                  value={mobile}
                  disabled={loading}
                  onChange={onChanegOfMobile}
                  // onKeyDown={onSubmit}
                  autocomplete="off"
                />

              </div>

              <div className=" input-container ">
                <img
                  className="input-icon"
                  src={lock}
                  alt=""
                />
                <input
                  style={inputStylePassword}
                  type={showPassword ? "text" : "password"}
                  id="myInput"
                  className="form-control col-6"
                  required={true}
                  value={password}
                  autoComplete="off"
                  onKeyDown={handleKeyDown}
                  placeholder="Password"
                  onChange={onChangeOfPassword}
                />
                <img
                  src={showPassword ? hideEyeIcon : eyeIcon}
                  alt="Toggle Password"
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
              <div className="forgot-password ">
                <Link



                  to="/forgetpassword"
                >
                  Forgot Password ?
                </Link>
              </div>


              <button
                type="submit"
                className="btn-submit"
                disabled={disabled || loading}
              >
                {loading ? <CircularProgress size={24} /> : "SIGN IN"}
              </button>
              <p className="signup-text">
                Don’t Have an Account?{" "}
                <Link to="/signup" className="signup-link">
                  Request Sign Up
                </Link>
              </p>

            </form>

          </div>

        </div>
      )}
    </>
  );
};

export default Login;
